import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  DateInput,
  BooleanInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const provinceChoices = [
  { id: 'AB', name: 'Alberta' },
  { id: 'BC', name: 'British Columbia' },
  { id: 'MB', name: 'Manitoba' },
  { id: 'NB', name: 'New Brunswick' },
  { id: 'NL', name: 'Newfoundland and Labrador' },
  { id: 'NS', name: 'Nova Scotia' },
  { id: 'ON', name: 'Ontario' },
  { id: 'PE', name: 'Prince Edward Island' },
  { id: 'QC', name: 'Quebec' },
  { id: 'SK', name: 'Saskatchewan' },
  { id: 'NT', name: 'Northwest Territories' },
  { id: 'NU', name: 'Nunavut' },
  { id: 'YT', name: 'Yukon' },
];

const countryChoices = [
  { id: 'CA', name: 'Canada' },
  { id: 'US', name: 'United States' },
];

export const DriverEmploymentCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Employment Details">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <ReferenceInput source="driverId" reference="drivers">
              <SelectInput optionText={(record: any) => record?.user?.name ? `${record.user.name} (Driver ID: ${record.id})` : `Driver ID: ${record?.id}`} validate={required()} fullWidth />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={6}>
            <BooleanInput source="current" defaultValue={false} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="company" validate={required()} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="title" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <DateInput source="startDate" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <DateInput source="endDate" fullWidth />
          </Grid>
          <Grid item xs={12}>
            <TextInput source="description" multiline rows={3} fullWidth />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Address">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextInput source="address1" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="address2" fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput source="city" fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput source="regionCode" choices={provinceChoices} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput source="countryCode" choices={countryChoices} defaultValue="CA" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="postalCode" fullWidth />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Contact Information">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BooleanInput source="contactHas" label="Contact Information Available" />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="contactName" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="contactTitle" fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput source="contactPhone" fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput source="contactPhoneExt" label="Extension" fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput source="contactEmail" type="email" fullWidth />
          </Grid>
        </Grid>
      </FormTab>
    </TabbedForm>
  </Create>
);